import { Injectable } from '@angular/core';
import {
    PushNotifications,
    PushNotification,
    PushNotificationToken,
    PushNotificationActionPerformed,
} from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { Router } from '@angular/router';
import { HttpService } from '../shared/services/http.service';

@Injectable({
    providedIn: 'root',
})
export class FcmService {
    constructor(private router: Router, private httpService: HttpService) {}

    initPush() {
        if (Capacitor.platform !== 'web') {
            this.registerPush();
        }
    }

    private registerPush() {
        PushNotifications.requestPermissions().then(permission => {
            if (permission.receive === 'granted') {
                PushNotifications.register();
            } else {
                // No permission for push granted
            }
        });

        PushNotifications.addListener('registration', (token: PushNotificationToken) => {
            const device = Capacitor.getPlatform();

            this.httpService
                .post('v2/app/aluno/fcm/register', {
                    token: token.value,
                    device: device,
                })
                .subscribe({
                    next: response => {
                        console.log(
                            'FCM token registered successfully: ' + JSON.stringify(response),
                        );
                    },
                    error: error => {
                        console.error('Error registering FCM token: ' + JSON.stringify(error));
                    },
                });
        });

        PushNotifications.addListener('registrationError', (error: any) => {
            console.log('Error: ' + JSON.stringify(error));
        });

        PushNotifications.addListener(
            'pushNotificationReceived',
            async (notification: PushNotification) => {
                console.log('Push received: ' + JSON.stringify(notification));
            },
        );

        PushNotifications.addListener(
            'pushNotificationActionPerformed',
            async (notification: PushNotificationActionPerformed) => {
                const data = notification.notification.data;
                console.log('Action performed: ' + JSON.stringify(notification.notification));
                if (data.detailsId) {
                    this.router.navigateByUrl(`${data.detailsId}`);
                }
            },
        );
    }
}
